import React from 'react';

export default class Mage extends React.PureComponent {

    render() {
        return (
            <div className="mage-wrapper">
                <div className="mage" />
            </div>
        );
    }
}

